module.exports = ".remote-nav[_ngcontent-c2] ul[_ngcontent-c2] li[_ngcontent-c2] a.active[_ngcontent-c2] {\r\n    color: #217aff;\r\n}"